import { cn } from "../../lib/cn";

/** Compact 0..1 score meter with numeric text (value never color-alone). */
export function ScoreBar({ label, value, className }: { label: string; value: number | null | undefined; className?: string }) {
  const v = value === null || value === undefined || !Number.isFinite(value) ? null : Math.max(0, Math.min(1, value));
  return (
    <div className={cn("grid grid-cols-[110px_1fr_40px] items-center gap-2 text-xs", className)}>
      <span className="text-fg-2">{label}</span>
      <div className="h-1.5 overflow-hidden rounded-full bg-panel-2" role="meter" aria-label={label} aria-valuemin={0} aria-valuemax={100} aria-valuenow={v === null ? undefined : Math.round(v * 100)}>
        {v !== null && <div className="h-full rounded-full bg-[var(--series-1)]" style={{ width: `${v * 100}%` }} />}
      </div>
      <span className="tabular text-right text-fg">{v === null ? "—" : Math.round(v * 100)}</span>
    </div>
  );
}

export function DatasetScore({ scores }: { scores: Partial<Record<"quality" | "completeness" | "reliability" | "freshness" | "exclusivity", number>> }) {
  return (
    <div className="space-y-2">
      <ScoreBar label="Quality" value={scores.quality} />
      <ScoreBar label="Completeness" value={scores.completeness} />
      <ScoreBar label="Freshness" value={scores.freshness} />
      <ScoreBar label="Reliability" value={scores.reliability} />
      <ScoreBar label="Exclusivity" value={scores.exclusivity} />
    </div>
  );
}

export function ScorePill({ value }: { value: number | null | undefined }) {
  if (value === null || value === undefined) return <span className="text-fg-3">—</span>;
  return <span className="tabular rounded border border-border bg-panel-2 px-1.5 py-0.5 text-xs text-fg">{value.toFixed(2)}</span>;
}
